import { InjectionToken } from '@angular/core';

import { Environment } from '../models/environment';

export const ENVIRONMENTSETTINGS = new InjectionToken<Environment>('environment-settings');
